import { render, staticRenderFns } from "./SelectBase.vue?vue&type=template&id=fad9b2ca&scoped=true&lang=pug"
import script from "./SelectBase.vue?vue&type=script&lang=ts"
export * from "./SelectBase.vue?vue&type=script&lang=ts"
import style0 from "./SelectBase.vue?vue&type=style&index=0&id=fad9b2ca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad9b2ca",
  null
  
)

export default component.exports